import ImagesSellGuideBottlesSvg from '@/public/images/sell-guide/bottles.svg';
import ImagesSellGuideCard6Svg from '@/public/images/sell-guide/card6.svg';
import ImagesSellGuideCard7Svg from '@/public/images/sell-guide/card7.svg';
import ImagesSellGuideGri1Svg from '@/public/images/sell-guide/gri1.svg';
import ImagesSellGuideGri2Svg from '@/public/images/sell-guide/gri2.svg';
import ImagesSellGuideGri3Svg from '@/public/images/sell-guide/gri3.svg';
import ImagesSellGuideGri4Svg from '@/public/images/sell-guide/gri4.svg';
import ImagesSellGuideGri5Svg from '@/public/images/sell-guide/gri5.svg';
import ImagesSellGuideLastJpg from '@/public/images/sell-guide/last.jpg';
import ImagesSellGuideMainBannerMobileWebp from '@/public/images/sell-guide/mainBannerMobile.webp';
import ImagesSellGuideNotSection8Svg from '@/public/images/sell-guide/not-section8.svg';
import ImagesSellGuideOption1TabSvg from '@/public/images/sell-guide/option1Tab.svg';
import ImagesSellGuideOption1botSvg from '@/public/images/sell-guide/option1bot.svg';
import ImagesSellGuideOption2TabSvg from '@/public/images/sell-guide/option2Tab.svg';
import ImagesSellGuideOption2botSvg from '@/public/images/sell-guide/option2bot.svg';
import ImagesSellGuideSection1Svg from '@/public/images/sell-guide/section1.svg';
import ImagesSellGuideSection2Svg from '@/public/images/sell-guide/section2.svg';
import ImagesSellGuideSection5Svg from '@/public/images/sell-guide/section5.svg';
import ImagesSellGuideSection8Svg from '@/public/images/sell-guide/section8.svg';
import ImagesSellGuideSellerGuideSvg from '@/public/images/sell-guide/seller-guide.svg';
import ImagesSellGuideSellerGuideWebp from '@/public/images/sell-guide/seller-guide.webp';
import ImagesSellGuideTagPng from '@/public/images/sell-guide/tag.png';

export {
  ImagesSellGuideBottlesSvg,
  ImagesSellGuideCard6Svg,
  ImagesSellGuideCard7Svg,
  ImagesSellGuideGri1Svg,
  ImagesSellGuideGri2Svg,
  ImagesSellGuideGri3Svg,
  ImagesSellGuideGri4Svg,
  ImagesSellGuideGri5Svg,
  ImagesSellGuideLastJpg,
  ImagesSellGuideMainBannerMobileWebp,
  ImagesSellGuideNotSection8Svg,
  ImagesSellGuideOption1TabSvg,
  ImagesSellGuideOption1botSvg,
  ImagesSellGuideOption2TabSvg,
  ImagesSellGuideOption2botSvg,
  ImagesSellGuideSection1Svg,
  ImagesSellGuideSection2Svg,
  ImagesSellGuideSection5Svg,
  ImagesSellGuideSection8Svg,
  ImagesSellGuideSellerGuideSvg,
  ImagesSellGuideSellerGuideWebp,
  ImagesSellGuideTagPng,
};
